import BWAccordion from 'components/shared/BWAccordion/index';
import FormEditorQuill from 'components/shared/BWFormControl/FormEditorQuill';
import React from 'react';

const JobBenefits = ({ disabled, title, id }) => {
  return (
    <BWAccordion title={title} id={id} isRequired>
      <FormEditorQuill
        field='benefits'
        disabled={disabled}
        validation={{
          required: 'Nội dung là bắt buộc',
        }}
      />
    </BWAccordion>
  );
};

export default JobBenefits;
